import { gql } from '@apollo/client';

export const QUERY_TRANSLATE = gql`
  query StaticTranslations($language: String) {
    staticTranslations(language: $language)
  }
`;

export const QUERY_GET_ALL_TRANSLATIONS = gql`
  query GetAllTranslations {
    getAllTranslations {
      key
      languageCount
      translations {
        value
        language
      }
    }
  }
`;
